import Marquee from "react-fast-marquee";

const items = [
  "DELIVERY MARACÁS",
  "RÁPIDO E FRESCO",
  "O MELHOR DA CIDADE",
  "MARACÁS · BAHIA",
  "PEÇA PELO APP",
];

export const BrandMarquee = () => (
  <div className="border-y border-maraca-navy/10 bg-maraca-navy py-6" data-testid="brand-marquee">
    <Marquee speed={45} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-8 flex items-center gap-8">
          <span className="font-display text-4xl font-extrabold uppercase tracking-tight text-white md:text-6xl">
            {t}
          </span>
          <span className="text-3xl text-maraca-amber md:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
